import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import Swal from 'sweetalert2';
import { getAllPricing, createPricing, updatePricing, deletePricing } from '../api/auth/pricingService';
import { getAllPlanTypes } from '../api/auth/planTypeService';
function Pricing() {
    const [data, setData] = useState([]);
    const [planTypes, setPlanTypes] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [values, setValues] = useState({
        plantype_id: '',
        price: ''
    });

    useEffect(() => {
        fetchPlanTypes();
        fetchPricingData();
    }, []);

    const fetchPricingData = async () => {
        try {
            const pricingData = await getAllPricing();
            setData(pricingData);
        } catch (error) {
            console.error('Error fetching pricing data:', error);
            Swal.fire('Error', 'Failed to load pricing data', 'error');
        }
    };

    const fetchPlanTypes = async () => {
        try {
            const planTypesData = await getAllPlanTypes();
            setPlanTypes(planTypesData);
        } catch (error) {
            console.error('Error fetching plan types:', error);
            Swal.fire('Error!', 'Failed to fetch plan types.', 'error');
        }
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setValues(prev => ({ ...prev, [name]: value }));
    };

    const handleEditClick = async (item) => {
        try {
            // const pricing = await getPricingById(item.id);

            // setPlanTypes(pricing.plantype);

            setEditingId(item.id);
            setValues({
                plantype_id: item.plantype?.id ? Number(item.plantype.id) : '',
                price: item.price || ''
            });
        } catch (error) {
            console.error('Error fetching pricing for edit:', error);
            Swal.fire('Error', 'Failed to load pricing details', 'error');
        }
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this record!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deletePricing(id);
                    setData(prev => prev.filter(item => item.id !== id));
                    Swal.fire('Deleted!', 'Pricing entry deleted.', 'success');
                } catch (error) {
                    Swal.fire('Error!', 'Failed to delete record.', 'error');
                    console.error('Delete error:', error);
                }
            }
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const plantypeId = parseInt(values.plantype_id);
        if (isNaN(plantypeId) || plantypeId <= 0 || !planTypes.some(type => type.id === plantypeId)) {
            Swal.fire('Error!', 'Please select a valid plan type.', 'error');
            return;
        }

        if (!values.price) {
            Swal.fire('Validation Error', 'Price is required.', 'warning');
            return;
        }

        const pricingData = {

            id: null,
            plantypeId: plantypeId,
            plantype: '',
            price: values.price,
            date: ''

        };

        try {
            if (editingId) {
                await updatePricing(editingId, pricingData);
                Swal.fire('Updated!', 'Pricing updated successfully.', 'success');
            } else {
                await createPricing(pricingData);
                Swal.fire('Created!', 'Pricing added successfully.', 'success');
            }
            setValues({ plantype_id: '', price: '' });
            setEditingId(null);
            fetchPricingData();
        } catch (error) {
            console.error('Save error:', error);
            Swal.fire('Error!', 'Failed to save pricing data.', 'error');
        }
    };

    return (
        <div>
            <Sidebar />
            <div className="col-md-9 px-0" style={{ marginLeft: '210px' }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <h5 className="page-title mt-3">Clinic Solution Update / Pricing</h5>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <form onSubmit={handleSubmit}>
                            <div className="row mb-3">
                                <div className="col-md-5">
                                    <label className="form-label">Plan Type</label>
                                    <select
                                        className="form-select"
                                        name="plantype_id"
                                        value={values.plantype_id}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Plan Type</option>
                                        {planTypes.map(type => (

                                            <option key={type.id} value={type.id}>
                                                {type.plantype}
                                            </option>
                                        ))}

                                    </select>
                                </div>

                                <div className="col-md-5">
                                    <label className="form-label">Price</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="price"
                                        value={values.price}
                                        onChange={handleChange}
                                        placeholder="Enter Price"
                                        required
                                    />
                                </div>

                                <div className="col-md-2 d-flex align-items-end">
                                    <button type="submit" className="btn btn-primary w-100">
                                        {editingId ? 'Update' : 'Save'}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="row mt-4">
                        <div className="col-md-12">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Plan Type</th>
                                        <th>Price</th>
                                        <th>Date</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.length > 0 ? (
                                        data.map((item, index) => (
                                            <tr key={item.id}>
                                                <td>{index + 1}</td>
                                                <td>{item.plantype?.planType || item.plantype || 'N/A'}</td>
                                                <td>{item.price}</td>
                                                <td>{item.date || 'N/A'}</td>
                                                <td>
                                                    <button className="btn btn-primary btn-sm me-2" onClick={() => handleEditClick(item)}>Edit</button>
                                                    <button className="btn btn-danger btn-sm" onClick={() => handleDelete(item.id)}>Delete</button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="text-center">No pricing data found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Pricing;